import { render, staticRenderFns } from "./TopPromoBars.vue?vue&type=template&id=30b722c0&scoped=true"
import script from "./TopPromoBars.vue?vue&type=script&lang=ts"
export * from "./TopPromoBars.vue?vue&type=script&lang=ts"
import style0 from "./TopPromoBars.vue?vue&type=style&index=0&id=30b722c0&prod&lang=scss"
import style1 from "./TopPromoBars.vue?vue&type=style&index=1&id=30b722c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b722c0",
  null
  
)

export default component.exports